var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserDropdownIcon07(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.33331 10.5003H3.49998V11.667H10.5V2.33366H3.49998V3.50033H2.33331V1.75033C2.33331 1.42816 2.59448 1.16699 2.91665 1.16699H11.0833C11.4055 1.16699 11.6666 1.42816 11.6666 1.75033V12.2503C11.6666 12.5725 11.4055 12.8337 11.0833 12.8337H2.91665C2.59448 12.8337 2.33331 12.5725 2.33331 12.2503V10.5003ZM3.49998 6.41699H7.58331V7.58366H3.49998V9.33366L0.583313 7.00033L3.49998 4.66699V6.41699Z",
    fill: "#1B1B1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserDropdownIcon07);
export default __webpack_public_path__ + "static/media/user-dropdown-icon--07.8d86f8ae12ef816b76a7108c6e7799b4.svg";
export { ForwardRef as ReactComponent };